<template>
  <!-- 数据集列表 -->
  <div class="dataset-list-card">
    <ul class="card-ul">
      <li class="no-data" v-if="Dataset.records.length === 0">
        <img :src="emptyImgUrl" alt="">
        <span>{{searchKey ? '未检索到符合条件的数据集' : '暂无数据集'}}</span>
      </li>
      <li
        :class="['card-list-items', datasetPageType == 0 ? 'card-list-items-hover':'']"
        v-for="(item, index) in Dataset.records"
        :key="index"
        @click="toPreview(item.datasetId, item.datasetName, item.datasetType)"
      >
        <div class="card-ashSetting" @click.stop="onCardAshSetting()" v-if="cardAshSettingFilter(item)">
          <i class="icon-invalid"></i>
        </div>
        <div class="title-div">
          <div class="title-div-left">
            <span class="icon-fine-mark" v-if="item.collectionNum >= 10">精</span>
            <tooltip-box
              class="title-name"
              :textRef="'datasetName'"
              :textId="item.datasetId"
              :textRow="1"
              :textName="item.datasetName"
              :placement="'top'"
              :tooltipShow="false"
            ></tooltip-box>
            <span :class="['icon-span', item.status == 1 ? 'icon-unlock':'icon-lock']" v-if="datasetPageType == 1"></span>
          </div>

          <div class="title-div-right">
            <span class="down" v-if="datasetPageType != 2" @click.stop="handleDownload(item,index)">
              <i :class="iconDownloadClassName(item)"></i>
              {{ item.downloadNum }}
            </span>

            <span
              class="star-mark"
              v-if="datasetPageType != 2"
              @click.stop="operateHandle(item.datasetId, item.datasetName, Number(item.isCollection))"
            >
              <i :class="['collect', iconStarClassName(item)]"></i>
              {{item.collectionNum}}
            </span>

            <span class="ispublic" v-if="datasetPageType == 0 && searchType == 1" @click.stop="operatePublic(item.datasetId, item.status, index)">
              <i :class="[item.status == 1 ? 'icon-unlock' : 'icon-lock']"></i>
              {{ item.status == 1 ? "已公开" : "未公开" }}
            </span>

            <!--编辑-->
            <span
              class="edit-icon"
              v-if="datasetPageType == 1 && searchType == 1"
              @click.stop="activeCreatePopup('edit', item)"
            >
              <i class="icon-edit"></i>
            </span>
            <!--删除-->
            <span
              class="delete-icon"
              v-if="datasetPageType == 0 && searchType == 1 || datasetPageType == 1 && searchType == 1"
              @click.stop="activeDeletePopup(item.datasetId, index)"
            >
              <i class="icon-delete"></i>
            </span>

            <!-- <span class="more-icon" v-if="datasetPageType == 1 && searchType == 1">
              <el-dropdown placement="right"> 
                <span class="el-dropdown-link">
                  <i class="icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item style="padding:0">
                    <div style="padding: 0 20px" @click="activeCreatePopup('edit', item)">编辑</div>
                  </el-dropdown-item>
                  <el-dropdown-item style="padding:0">
                    <div style="color: #CC0000; padding: 0 20px;" @click="activeDeletePopup(item.datasetId, index)">删除</div>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span> -->
          </div>
        </div>

        <tooltip-box
          class="content-over-flow"
          :textRef="'datasetContent'"
          :textId="item.datasetId"
          :textRow="3"
          :textName="item.datasetContent"
          :placement="'bottom'"
          :tooltipShow="false"
        ></tooltip-box>

        <div class="info">
          <span>
            <el-tooltip class="item" effect="light" content="数据集创建者" placement="top" :enterable="false">
              <i class="user"></i>
            </el-tooltip>
            <tooltip-box
              :textRef="'createName'"
              :textRow="1"
              :textWidth="'100px'"
              :textName="item.createName"
              :placement="'top'"
              :tooltipShow="false"
            ></tooltip-box>
          </span>
          <span>
            <el-tooltip class="item" effect="light" content="最近更新时间" placement="top" :enterable="false">
              <i class="date"></i>
            </el-tooltip>
            {{ item.createTime ? item.createTime : item.updateTime | moment("YYYY.MM.DD") }}
          </span>

          <span>
            <el-tooltip class="item" effect="light" content="数据类型和行业领域" placement="top" :enterable="false">
              <i class="label"></i>
            </el-tooltip>
            <el-tooltip
              class="item"
              effect="light"
              offset="-200"
              placement="top-end"
              :content="getIndustryShow(item.datasetId)"
              :disabled="getIndustryShow(item.datasetId) !== '' ? false : true"
              :enterable="false"
            >
              <ul class="info-Label-ul" :id="item.datasetId + searchType">
                <li>{{datasetTypeFilter(item.datasetType)}}</li>
                <li class="label-li" v-for="(itm, idx) in item.industryFieldArr" :key="idx">
                  {{onInfoIndustryList(item.industryFieldArr, idx, item.datasetId)}}
                </li>
                <li class="ellipsis" v-if="getIndustryShow(item.datasetId)">...</li>
              </ul>
            </el-tooltip>
          </span>

          <span>
            <el-tooltip class="item" effect="light" content="累计查看次数" placement="top" :enterable="false">
              <i class="see"></i>
            </el-tooltip>
            {{ item.clickNum }}
          </span>
          <span>
            <el-tooltip class="item" effect="light" content="累计被引用次数" placement="top" :enterable="false">
              <i class="quote"></i>
            </el-tooltip>
            {{ item.quoteNum }}
          </span>
          <span>
            <el-tooltip class="item" effect="light" content="数据集总体积" placement="top" :enterable="false">
              <i class="size"></i>
            </el-tooltip>
            {{ $util.fileSizeTranfor(item.fileSize, 2) + "B" }}
          </span>
          <span>
            <el-tooltip class="item" effect="light" content="数据集总文件数" placement="top" :enterable="false">
              <i :class="['count',
                item.datasetType==1 || item.datasetType==2 ?
                'icon-img' : (item.datasetType==3 || item.datasetType==4 ? 'icon-txt':'icon-audio')]"
              ></i>
            </el-tooltip>
            {{ item.fileNum }}Files
          </span>
        </div>
      </li>
    </ul>

    <div class="popup-list">
      <!-- 新建项目 -->
      <gat-popup
        id="popup-create"
        :class="[
          'popup-create',
          popupActive === 'create' || popupActive === 'edit' ? 'on' : 'off',
        ]"
        :title="popupActive==='edit' ? '编辑数据集':'创建数据集'"
        :primary-button="popupActive==='edit' ? '保存':'创建'"
        @cancel="cancelPopup"
        @confirm="createNewProject"
      >
        <template v-slot:content>
          <el-form
            class="pop-el-form"
            :model="NewDataset"
            :rules="rules"
            ref="popupUploadForm"
          >
            <el-form-item prop="datasetName">
              <div class="intxt">
                <span class="label"><i class="required">*</i>数据集名称</span>
                <el-input
                  placeholder="请输入数据集名称，必填项"
                  v-model.trim="NewDataset.datasetName"
                  maxlength="20"
                  show-word-limit
                />
              </div>
            </el-form-item>
            <el-form-item prop="datasetContent">
              <div class="intxt">
                <span class="label"><i class="required">*</i>数据集简介</span>
                <el-input
                  class="pop-textarea"
                  type="textarea"
                  placeholder="请输入数据集简介，必填项"
                  v-model.trim="NewDataset.datasetContent"
                  :rows="5"
                  maxlength="200"
                  show-word-limit
                ></el-input>
              </div>
            </el-form-item>

            <el-form-item prop="datasetType">
              <div class="intxt">
                <span class="label"><i class="required">*</i>数据集类型</span>
                <el-select
                  class="selection-wrap"
                  v-model="NewDataset.datasetType"
                  clearable
                  placeholder="请选择数据集类型，必选项"
                  filterable
                  :disabled="popupActive === 'edit'"
                >
                  <el-option
                    v-for="item in datasetOptions"
                    :key="item.dictId"
                    :label="item.dictTypeDesc"
                    :value="item.dictId"
                  ></el-option>
                </el-select>
              </div>
            </el-form-item>

            <el-form-item prop="selectIndustryList">
              <div class="intxt">
                <span class="label"><i class="required">*</i>行业领域</span>
                <div class="select-industry" @click.stop="">
                  <!-- 表单选中列表 -->
                  <el-tooltip
                    class="item"
                    effect="light"
                    :content="NewDataset.selectLabel"
                    placement="top-end"
                    :disabled="NewDataset.selectLabel ? false : true"
                    :enterable="false"
                  >
                    <p 
                      :class="[
                        NewDataset.selectLabel ? '' : (redDorderColorShow ? 'p-borderColor-red' : ''),
                        industryOptionShow ? 'p-borderColor-blue' : ''
                      ]"
                      @click.stop="onSelectOption()"
                    >
                      <ul id="selectLabel-ul" class="selectLabel-ul" v-if="NewDataset.selectIndustryList.length">
                        <li class="label-li" v-for="(item, index) in NewDataset.selectIndustryList" :key="index">
                          {{item}}
                        </li>
                        <li style="background: #fff;" v-if="beyondEllipsisShow">...</li>
                      </ul>
                      <span class="placeholder-span" v-else>请选择行业领域，必选项</span>
                      <span class="icon-span">
                        <i class="el-icon-circle-close" v-if="NewDataset.selectIndustryList.length" @click.stop="onDeleteLabelAll()"></i>
                        <i :class="['el-icon-arrow-down', industryOptionShow ? 'el-icon-rotate':'']"></i>
                      </span>
                    </p>
                  </el-tooltip>
                  <!-- 行业领域下拉窗 -->
                  <el-collapse-transition>
                    <div class="select-option" v-if="industryOptionShow">
                      <i class="popper-arrow">&#9670;</i>
                      <h6>请选择1-5个标签</h6>
                      <el-divider></el-divider>
                      <ul class="industry-ul">
                        <li 
                          :class="[selectLabelFlag(item) ? 'select-li' : '']"
                          v-for="(item, index) in industryList" :key="index"
                          @click.stop="onSelectLabel(item)"
                        >
                          <span>{{item}}</span>
                        </li>
                      </ul>
                      <el-divider></el-divider>
                      <span class="select-title">已选标签：</span>
                      <ul class="select-industry-ul">
                        <li v-for="(item, index) in NewDataset.selectIndustryList" :key="index">
                          {{item}}
                          <i class="el-icon-close" @click.stop="onDeleteLabel(item, index)"></i>
                        </li>
                        <li :class="['add-label-li', addLabelShow?'no-border-li':'']" v-if="NewDataset.selectIndustryList.length < 5">
                          <div v-if="addLabelShow">
                            <input
                              type="text"
                              class="add-label-input"
                              v-model.trim="addLabelName"
                              @blur="addCustomLabel()"
                              @keyup.enter="addCustomLabel()"
                            />
                          </div>
                          <div v-else @click.stop="onCustomLabel()">
                            <i class="el-icon-plus"></i>
                            自定义标签
                          </div>
                        </li>
                      </ul>
                    </div>
                  </el-collapse-transition>
                </div>
              </div>
            </el-form-item>

            <el-form-item prop="">
              <div class="intxt">
                <span class="label"><i class="required">*</i>是否公开</span>
                <div class="radio-div">
                  <el-radio v-model="NewDataset.radioLabel" label="1">是</el-radio>
                  <el-radio v-model="NewDataset.radioLabel" label="0">否</el-radio>
                </div>
                <p class="tip-p">数据集公开后可被其他用户访问、收藏和引用。</p>
              </div>
            </el-form-item>
          </el-form>
        </template>
      </gat-popup>

      <!-- 删除 -->
      <gat-popup
        :class="['popup-delete', popupActive === 'delete' ? 'on' : 'off']"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="confirmDelDataset"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                    class="icon-info-help"
                    :icon-name="Icons.InfoHelp.iconName"
                    v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
               <span class="title">确定删除该数据集吗？</span>
            </div>

            <div class="content">删除后可在 “回收站” 恢复哦</div>
          </div>
        </template>
      </gat-popup>

      <!-- 是否公开数据集 -->
      <gat-popup
        :class="['popup-open', popupActive === 'open' ? 'on' : 'off']"
        :title="''"
        :primary-button="'确定'"
        @cancel="cancelPopup"
        @confirm="onIsItpublicOpen"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <span class="title"></span>
            </div>
            <div class="content">
              {{openPublicData.status == 0 ? "确定公开该数据集吗？" : "确定取消公开该数据集吗？"}}
            </div>
          </div>
        </template>
      </gat-popup>
    </div>
  </div>
</template>

<script>
import DATASETLOBBY from '@/axios/datasetLobby/datasetLobby.js'
import PRETRAIN from '@/axios/pretrain/pretrain.js'

import TooltipBox from '@/components/common/TooltipBox'
// import PopupDeleteBox from '@/components/common/PopupDeleteBox'
import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'

import { debounce } from 'lodash' // 引入lodash数组函数方法

export default {
  name: "DatasetListCard",
  components: { 
    GatPopup,
    IconInfoHelp,
    TooltipBox,
    // PopupDeleteBox
  },
  props: {
    datasetData: {
      type: Object,
      default: {}
    },
    // 数据页面类型：0数据大厅,1数据大厅详情，2引用数据集详情
    datasetPageType: {
      type: Number,
      default: null
    },
    searchType: {
      type: String,
      default: ''
    },
    searchKey: {
      type: String,
      default: ''
    },
    isAdd: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      userId: '', // 当前用户userId
      popupActive: '',
      Icons: {
        InfoHelp: {
          iconName: "",
          viewBox: "0 0 36 36",
          width: "36",
          height: "36"
          // iconColor: "#fff"
        }
      },
      currentPage: 1,
      Dataset: {
        records: [],
        size: 10,
        currentPage: 1,
        total: 0
      },
      datasetListIndustryShow: [], // 数据集列表标签超出部分显示
      delDatasetId: null,
      datasetOptions: [], // 下拉列表数据集类型
      industryOptionShow: false,
      NewDataset: {
        datasetId: "0",
        datasetName: "",
        datasetContent: "",
        datasetType: "",
        selectLabel: "",
        selectIndustryList: [],
        radioLabel: "0",
      },
      rules: {
        datasetName: [{ required: true, message: '请输入数据集名称，必填项' }],
        datasetContent: [{ required: true, message: '请输入数据集简介，必填项' }],
        datasetType: [{ required: true, message: "请选择数据集类型，必选项" }],
        selectIndustryList: [{ required: true, message: "请选择行业领域，必选项" }],
      },
      industryList: [
        '农业', '建筑', '物流', '环保', '安防', '金融', '零售', '教育', '智能制造', '医疗', '体育',
      ],
      addLabelName: '', 
      addLabelShow: false,
      beyondEllipsisShow: false, // 创建数据集行业选中超出显示省略号
      redDorderColorShow: false,
      openPublicData: {
        datasetId: '',
        status: 0,
      },
      emptyImgUrl: require('../../../assets/images/datasetLobby/icon-empty-box.png'),
      clickFlag: false,
      isShowTooltip: true,
      fullscreenLoading:null,
    }
  },
  computed: {
  },
  watch: {
    datasetData: {
      handler(val) {
        if (val) {
          this.Dataset = val
        } else {
          this.Dataset = {
            records: [],
            size: 10,
            currentPage: 1,
            total: 0
          }
        }
        this.datasetListIndustryShow = [] // 清空数据集列表标签超出部分显示
        this.clickFlag = false // 重置收藏按钮
      },
      deep: true,
      immediate: true,
    },
    Dataset(Dataset) {
      this.currentPage = Dataset.current;
    },
    // 监听选择行业列表
    'NewDataset.selectIndustryList': {
      handler(list) {
        this.NewDataset.selectLabel = ''
        this.beyondEllipsisShow = false
        setTimeout(() => {
          let ulWidth = 0;
          let liListWidth = 0;
          let ul = document.getElementById('selectLabel-ul');
  
          if (ul) {
            ulWidth = ul.offsetWidth - 13; // 展示区总宽度 - 预留省略号位置

            let industryListShow = [];
            let liList = ul.childNodes;
            liList = Array.from(liList);
            liList = liList.filter(item => item.className === "label-li");
            
            liList.forEach(item => {
              item.style.display = 'block' // 重置显示
              let itemWidth = item.offsetWidth + 8; // 每个展示标签的宽度 + 间隔宽度
              liListWidth += itemWidth
              if (liListWidth > ulWidth) { // 判断标签是否超出
                item.style.display = 'none' // 标签超出隐藏
                this.beyondEllipsisShow = true // 显示‘...’
                industryListShow.push(item.textContent) // 追加超出的标签
              }
            });

            let industryLabel = industryListShow.toString();
            if (industryLabel) { // 为空过滤掉
              this.NewDataset.selectLabel = industryLabel // 获取当前超出的标签
            }
          }

          // 选择行业领域完毕触发验证
          if (list.length) {
            this.redDorderColorShow = false
            this.$refs.popupUploadForm.validateField('selectIndustryList', (val) => {})
          } 
          if (this.industryOptionShow && list.length == 0) {
            this.redDorderColorShow = true
            this.$refs.popupUploadForm.validateField('selectIndustryList', (val) => {})
          }
          // this.$forceUpdate();
        }, 100);
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.userId = this.$store.state.accountInfo.userId; // 当前用户userId
    this.getModelType(); // 获取模型类型数据
    this.getIndustryField(); // 获取行业领域
  },
  mounted() {},
  methods: {
    // 获取模型类型数据
    getModelType() {
      PRETRAIN.getModelType().then((result) => {
        if (result.isSuccess || result.returnCode === 200) {
          this.datasetOptions = result.data;
        }
      })
    },
    // 数据集类型过滤返回名称
    datasetTypeFilter(type) {
      let datasetLabel = '';
      this.datasetOptions.forEach(item => {
        if (item.dictId == type) {
          datasetLabel = item.dictTypeDesc;
        }
      });
      return datasetLabel
    },
    // 数据集列表置灰
    cardAshSettingFilter(val) {
      let flag = false // true显示置灰
      if (this.searchType == 2) {
        // deletedFlag：0 没有删除
        // status 0 不公开，1 已公开
        if (this.userId === val.createBy) { // 自己创建的数据集
          flag = val.deletedFlag != 0
        } else { // 他人创建的数据集
          // 数据集是否未删除？已删除显示置灰, 未删除-判断不公开状态显示置灰
          flag = val.deletedFlag != 0 ? true : (val.status == 0 ? true : false)
        }
      }
      return flag
    },
    // 下载状态图标
    iconDownloadClassName(val) {
      let iconDownloadClass = 'icon-download-blue'
      iconDownloadClass = this.cardAshSettingFilter(val) ? 'icon-download-ash' : 'icon-download-blue'
      return iconDownloadClass
    },
    // 星星状态图标
    iconStarClassName(val) {
      let iconStarClass = 'icon-star-empty'
      let isCollection = Number(val.isCollection)
      if (this.cardAshSettingFilter(val)) { // 判断是否置灰状态
        // iconStarClass = isCollection ? 'icon-star-ash-invalid' : 'icon-star-empty-invalid'
        iconStarClass = isCollection ? 'icon-star-yellow' : 'icon-star-empty-invalid'
      } else { // 不置灰状态
        iconStarClass = isCollection ? 'icon-star-yellow' : 'icon-star-empty'
      }
      return iconStarClass
    },

    // 跳转到数据集详情页面
    toPreview(datasetId, datasetName, datasetType) {
      if (this.datasetPageType == 0) {
        this.$router.push({
          name: "dataset-preview",
          query: {
            searchType: this.searchType, // nav类型：0公开数据集，1个人数据集，2我的数据集
            datasetId: datasetId, // 当前数据集id
            datasetName: datasetName, // 当前数据集名称
            datasetType: datasetType, // 数据集类型：1图像分类，2图像检测，3文本分类，4文本标注，5音频分类，6音频标注
            isAdd: 1, // 增加一次查看数：0不增，1增加
            datasetPageType: 1, // 数据页面类型：0数据大厅,1数据大厅详情，2引用数据集详情
          }
        });
      }
    },
    onCardAshSetting() {
      this.$message.error('该数据集不存在');
    },
    // 行业领域下拉收起弹窗
    onSelectOption() {
      this.industryOptionShow = !this.industryOptionShow
      this.addLabelShow = false
    },
    //返回是否添加过的标签
    selectLabelFlag(labelName) {
      return this.NewDataset.selectIndustryList.some(item => {
        return item === labelName
      });
    },
    // 选中标签
    onSelectLabel(labelName) {
      this.addLabelShow = false
      this.addLabelName = ''
      if (this.NewDataset.selectIndustryList.length >= 5) {
        return this.$message.error('最多可选5个标签')
      }
      let flag = this.NewDataset.selectIndustryList.every(item => {
        return item !== labelName
      });
      if (flag) {
        this.NewDataset.selectIndustryList.push(labelName)
      } else {
        // this.$message.error('已选中该标签')
      }
    },
    // 删除选中标签
    onDeleteLabel(labelName, index) {
      this.NewDataset.selectIndustryList.splice(index, 1)
    },
    // 删除全部选中标签
    onDeleteLabelAll() {
      this.NewDataset.selectIndustryList = []
      // 清空触发验证
      if (this.NewDataset.selectIndustryList.length == 0) {
        this.redDorderColorShow = true
        this.$refs.popupUploadForm.validateField('selectIndustryList', (val) => {})
      }
    },
    // 点击自定义标签
    onCustomLabel() {
      this.addLabelShow = true
      this.addLabelName = ''
    },
    // 确认自定义标签
    addCustomLabel() {
      if (this.addLabelName.length > 10) {
        return this.$message.error('最多可输入10个字~')
      }
      if (this.selectLabelFlag(this.addLabelName)) {
        return this.$message.error('此标签已添加过啦~')
      }
      if (this.checkLabelValue(this.addLabelName)) {
        return
      }
      this.addLabelShow = false
      if (this.addLabelName) {
        this.onSelectLabel(this.addLabelName)
      }
    },
    // 检测标题命名值
    checkLabelValue(value) {
      var result = false;
      if (value) {
        if (!/^[\u4e00-\u9fa5\_A-Za-z0-9]+$/.test(value)) {
          this.$message.error("标签名称只能由汉字、字母、数字组成");
          result = true;
        }
      }
      return result;
    },
    // 获取行业领域
    getIndustryField() {
      DATASETLOBBY.getIndustryField().then(result => {
        if (result.isSuccess) {
          let list = []
          let dataList = result.data
          dataList.forEach(item => {
            list.push(item.text)
          });
          this.industryList = list
        }
      });
    },
    // 新建项目
    activeCreatePopup(type, item) {
      if (type === 'edit') { // 编辑
        let data = JSON.parse(JSON.stringify(item))
        this.NewDataset = {
          datasetId: data.datasetId,
          datasetName: data.datasetName,
          datasetContent: data.datasetContent,
          datasetType: data.datasetType,
          selectLabel: data.industryFieldArr.toString(),
          selectIndustryList: data.industryFieldArr,
          radioLabel: data.status.toString(),
        };
        this.$refs.popupUploadForm.resetFields()
        this.popupActive = "edit";
      } else { // 创建
        this.NewDataset = {
          datasetId: "0",
          datasetName: "",
          datasetContent: "",
          datasetType: "",
          selectLabel: "",
          selectIndustryList: [],
          radioLabel: "0",
        };
        this.$refs.popupUploadForm.resetFields()
        this.popupActive = "create";
      }
      // 弹窗添加点击事件
      setTimeout(() => {
        let popup = document.getElementById('popup-create')
        popup.onclick = () => {
          this.industryOptionShow = false // 点击弹窗面板收起行业领域弹窗
        }
      }, 100);
    },
    // 提交按钮
    createNewProject() {
      this.industryOptionShow = false
      this.$refs.popupUploadForm.validate((valid) => {
        if (valid) {
          let data = {
            datasetName: this.NewDataset.datasetName,	// 数据集名称
	         	datasetContent: this.NewDataset.datasetContent, // 数据集简介
            datasetType: this.NewDataset.datasetType,	// 数据集类型：1为图像分类，2为物体检测，3为文本分类，4为文本标注，5为音频分类，6为音频标注
            industryFieldArr: this.NewDataset.selectIndustryList, // industryFieldArr
            isPublic: this.NewDataset.radioLabel, // 是否公开：0为不公开，1为公开
          }

          if (this.popupActive === "edit") { // 详情列表编辑数据集
            data.datasetId = this.NewDataset.datasetId // 数据集id
            DATASETLOBBY.updateDataset(data).then((result) => {
              if (result.isSuccess) {
                this.searchType = '1'
                this.$emit('getDatasetList', 1)
                this.cancelPopup();
                this.$message.success('编辑数据集成功！');
              } else {
                this.$message.error(result.returnMsg);
              }
            });
          } else { // 数据大厅创建数据集
            DATASETLOBBY.insertDataset(data).then((result) => {
              if (result.isSuccess) {
                this.searchType = '1'
                this.$emit('getDatasetList', 1)
                this.cancelPopup();
                this.$message.success(result.returnMsg);
                // 创建成功跳转数据集详情
                this.$router.push({
                  name: "dataset-preview",
                  query: {
                    searchType: this.searchType, // nav类型：0公开数据集，1个人数据集，2我的数据集
                    datasetId: result.data, // 当前数据集id
                    datasetName: this.NewDataset.datasetName, // 当前数据集名称
                    datasetType: this.NewDataset.datasetType, // 数据集类型：1图像分类，2图像检测，3文本分类，4文本标注，5音频分类，6音频标注
                    isAdd: 1, // 增加一次查看数：0不增，1增加
                    datasetPageType: 1, // 数据页面类型：0数据大厅,1数据大厅详情，2引用数据集详情
                  }
                });
              } else {
                this.$message.error(result.returnMsg);
              }
            });
          }
          
        } else {
          // this.$message.error('请将项目相关内容填写完整')
          this.redDorderColorShow = true
        }
      })
    },
    // 删除
    activeDeletePopup(datasetId) {
      this.delDatasetId = datasetId;
      this.popupActive = "delete";
    },
    /**
     ** 删除数据集 @data datasetId 数据集id
     */
    async confirmDelDataset(){
      let data = {
        datasetId: this.delDatasetId,
      };

      let res = await DATASETLOBBY.deletePubDataset(data);
      if (res &&res.isSuccess) {
        this.$message.success(res.returnMsg || "数据集刪除成功")
        this.cancelPopup()
        if (this.datasetPageType == 0) {  // 数据大厅列表
          if (this.Dataset.current > 1 && this.Dataset.records.length === 1) {
            this.$emit('getDatasetList', this.Dataset.current - 1)
          } else {
            this.$emit('getDatasetList', this.Dataset.current)
          }
        }
        if (this.datasetPageType == 1) { // 详情列表
          this.$router.push({
            name: "dataset-lobby",
            query: { searchType: this.searchType }
          });
        } 
      } else {
        this.$message.error(res.returnMsg)
        this.cancelPopup()
      }
    },
    // 收藏、取消收藏操作
    operateHandle(datasetId, datasetName, statusType) {
      if (this.clickFlag) { // 判断连接点击多次只执行第一次
        return
      }
      this.clickFlag = true

      let msgs = {
          cancel_collect: "成功取消收藏",
          collect: "收藏成功"
        },
        status = statusType === 0 ? 1 : 0,
        params = {
          datasetId: datasetId, // 数据集id
          datasetName: datasetName, // 数据集名称
          status: status, // 状态，0：未收藏，1：收藏
          datasetHallType: this.searchType, // 数据集大厅类型：0公开数据，1个人上传，2个人收藏
        };

      DATASETLOBBY.collectionPubDataset(params).then((result) => {
        if (result.isSuccess) {
          this.$emit('getDatasetList', this.Dataset.current);
          this.$message({
            message: status === 1 ? msgs.collect : msgs.cancel_collect,
            type: "success",
            duration: 2000
          });
          if (this.datasetPageType == 1 && this.searchType == 2) { // 详情列表 && 我的收藏
            this.$router.push({
              name: "dataset-lobby",
              query: { searchType: this.searchType }
            });
          }
        } else {
          this.$message.error(result.returnMsg)
          if (result.returnCode == 501) { // 501：数据集不存在
            this.$emit('getDatasetList', this.Dataset.current);
          }
        }
      }).catch(() => {
        this.clickFlag = false
      });
    },
    //公开切换
    operatePublic(datasetId, typeStr, index) {
      this.openPublicData = {
        datasetId: datasetId,
        status: typeStr,
      }
      this.popupActive = 'open'
    },
    // 确认是否公开
    onIsItpublicOpen() {
      let params = {
        datasetId: this.openPublicData.datasetId,
        status: this.openPublicData.status == 1 ? 0 : 1
      };

      DATASETLOBBY.openPubDataset(params).then((result) => {
        if (result.isSuccess) {
          this.$emit('getDatasetList', this.Dataset.current);
          this.$message({
            message: this.openPublicData.status == 1 ? "已取消公开" : "公开成功",
            type: "success",
            duration: 2000
          });
          this.cancelPopup();
        }
      });
    },
    //显示下载进度函数
    progressHandler(ProgressEvent,dataset,porcessId) {
      if(ProgressEvent) {
        let loaded = ProgressEvent.loaded;
        let fileSize = dataset.fileSize ;
        this.percentage = 0;
        this.percentage = parseInt((loaded/fileSize)*100);
        
        this.$progressDialog.onPorcess(porcessId,this.percentage);
      }
    },
    LoadingHandler(type) {
      this.fullscreenLoading = this.$loading({
        lock: true,
        text: `${this.modelTypeCompany(type)}下载中请稍等...`,
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
    },
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    // 下载
    handleDownload:debounce (function(val,index) {
      let this_ = this
      if (this_.cardAshSettingFilter(val)) { // 判断数据集列表置灰
        return
      }
      let params = {
        datasetId: val.datasetId, // 数据集id
        datasetName: val.datasetName, // 数据集名称
        datasetType: val.datasetType, // 数据类型
        datasetHallType: this_.searchType, // 数据集大厅类型：0公开数据，1个人上传，2个人收藏
      };
      let timestamp =new Date().getTime();
       //进度条插件处理 fileSize> 0表示有文件
      if(Number(val.fileSize)>0) {
        //开始一个下载进程
        let porcess ={
          name :val.datasetName,
          porcessId:timestamp,
          progress:0,
          show:false,
        }
        this.$progressDialog.addPorcess(porcess);
      }

      //监听http请求进度
      const onProgress = (ProgressEvent) => {
        if(Number(val.fileSize)>0) {
          this.progressHandler(ProgressEvent,val,timestamp)
        }
      }

      //改变下载数量
      this.changeDownloadNum(index)

      // this.LoadingHandler(val.datasetType)
      // 通过数据集ID下载文件
      DATASETLOBBY.downPubDataset(params,onProgress).then((result) => {
        // this.fullscreenLoading.close()
        if(Number(val.fileSize)>0){
          this.$progressDialog.onPorcess(timestamp,100)
        }
        const data = result;
       

        // debugger
        if (result.type === 'application/json') { // 判断是否JSON格式:application/json
          // 处理返回的信息转JSON对象 
          const blob = new Blob([data], {type: 'application/json'});
          const reader = new FileReader();
          reader.onloadend = function(e) {
            const res = e.target.result
            const msg = JSON.parse(res)
            this_.$message.error(msg.returnMsg);
            if (msg.returnCode == 501) { // 501：数据集不存在
              this_.$emit('getDatasetList', this_.Dataset.current);
            }
          }
          reader.readAsText(blob);
        } else { // 文件流格式: application/x-msdownload
          // 处理返回的文件流下载
          const blob = new Blob([data], {type: 'application/zip'});
          const blobUrl = window.URL.createObjectURL(blob);
          // 下载构建
          this_.$util.createDownload(blobUrl, val.datasetName);
          // 刷新数据集详情
          this_.$emit('getDatasetList', this_.Dataset.current);
        }
      }).catch((error) => {
        this.$message.error('下载失败!');
      });
    }, 500),

    // 数据集列表返回超出的行业标签
    getIndustryShow(datasetId) {
      let industryString = '';
      this.datasetListIndustryShow.forEach(item => {
        if (item.datasetId === datasetId) {
          industryString = item.industryText;
        }
      })
      return industryString
    },
    // 数据集列表返回超出的行业标签隐藏
    onInfoIndustryList(list, idx, datasetId) {
      let labelList = list
      setTimeout(() => {
        let ul = document.getElementById(datasetId + this.searchType);

        if (ul) {
          let industryListShow = [];
          let liListWidth = 0;
          let liList = ul.childNodes;
          liList = Array.from(liList);
          liList = liList.filter(item => item.className === "label-li");

          liListWidth = liList[0].offsetWidth + 5; // 第一个数据集类型标签的宽度 + 间隔宽度
          liList.forEach(item => {
            item.style.display = 'block'; // 重置显示
            let itemWidth = item.offsetWidth + 5; // 每个展示标签的宽度 + 间隔宽度
            liListWidth += itemWidth;
            if (liListWidth > 490) {
              item.style.display = 'none'; // 超出隐藏
              industryListShow.push(item.textContent); // 追加超出标签
            }
          });

          // let liLength = liList.length - 1 
          // 判断超出 && 判断没有“...”
          // if (liListWidth > 490 && liList[liLength].textContent !== '...') {
          //   // 创建li标签追加“...”
          //   const $li = document.createElement('li');
          //   $li.textContent = '...'
          //   $li.style.height = '18px'
          //   $li.style.lineHeight = '18px'
          //   ul.appendChild($li);
          // }

          let industryText = industryListShow.toString() || '';
          if (industryText) { // 为空过滤掉
            // 判断数组中没有该数据集，追加数据集超出的标签
            let flag = this.datasetListIndustryShow.every(item => {
              return item.datasetId !== datasetId
            })
            if (flag) {
              this.datasetListIndustryShow.push({
                datasetId: datasetId,
                industryText: industryText,
              })
            }
          }
        }
        // this.$forceUpdate(); 
      }, 100);
      return labelList[idx]
    },
    changeDownloadNum(idx){
      this.$nextTick(()=>{
        let list =this.Dataset.records ||[]
        this.Dataset.records.map(function a(dataset,index){
          if(index ==idx){
            dataset.downloadNum =dataset.downloadNum +1  
          }
          return dataset
        })
        this.Dataset.records =list
      })
    },

    //  取消弹窗
    cancelPopup() {
      this.popupActive = "";

      this.redDorderColorShow = false
      this.industryOptionShow = false
      this.addLabelShow = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import './DatasetListCard';
</style>

<style>
  .el-tooltip__popper.is-light {
    border: 1px solid #ccc;
  }
  .el-tooltip__popper .popper__arrow {
    /* 上方箭头 */
    border-top-color: #ccc !important;
    /* 下方箭头 */
    border-bottom-color: #ccc !important;
  }
  .el-tooltip__popper .popper__arrow::after {
    /* 上方箭头 */
    border-top-color: #fff !important;
    /* 下方箭头 */
    border-bottom-color: #fff !important;
  }
</style>